const ICON_SIZE = {
  SIZE_16: 16,
  SIZE_20: 20,
  SIZE_24: 24,
  SIZE_32: 32,
  SIZE_40: 40,
  SIZE_48: 48,
  SIZE_50: 50,
};

export default ICON_SIZE;
